import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Login.module.scss';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from 'actions/auth-actions';
import { Alert, Box, Button, FormControl, Switch, TextField, Typography } from '@mui/material';
import { useAppSelector } from 'setup/store';
import Images from 'assets/images/common';
import LoadingSpinner from 'components/lib/UI/loadingSpinner/LoadingSpinner';
import { Link } from 'react-router-dom';

function ForgotPasswordForm() {
  const { forgotPassword, setError } = useAuthContext();
  const [username, setUserName] = useState('test');
  const [errorInputUsername, setErrorInputUsername] = useState<string>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const error = useAppSelector((state) => state.authReducer.error);
  const loading = useAppSelector((state) => state.authReducer.loading);

  const _onNextPressed = async (e: React.FormEvent) => {
    e.preventDefault();
    const isValidUsername = username && username.length > 0 ? true : false;

    if (!isValidUsername) {
      setErrorInputUsername(t('error.blankUsername'));
    } else {
      setErrorInputUsername(undefined);
    }
    setError(null);
    if (isValidUsername) {
      const resp = await forgotPassword(username);
      if (resp) {
        navigate('/reset-password?username=' + username);
      }
    } else {
    }
  };

  return (
    <Box sx={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <div className={`${classes.container}`}>
        <div className={classes.background}>
          <div className={classes.overlay}></div>
          <img src={Images.LoginBackground4} alt="Login background" />
        </div>
        <div className={classes.loginBox}>
          <div className={classes.logo}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
              <img src={Images.LoginBranding} className={classes.brandingImg} />
            </Box>
          </div>

          <Box
            component="form"
            sx={
              {
                // '& .MuiTextField-root': { m: 1, width: '25ch' },
              }
            }
            className={classes.formContainer}
            onSubmit={_onNextPressed}
          >
            <div>
              <FormControl fullWidth className={classes.rowItem}>
                <TextField
                  fullWidth
                  error={errorInputUsername && errorInputUsername.length > 0 ? true : false}
                  id="outlined-error-helper-text"
                  label="Username"
                  value={username}
                  helperText={errorInputUsername}
                  placeholder="Enter username"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setError(null);
                    setUserName(event.target.value);
                  }}
                />
              </FormControl>
              {error ? (
                <FormControl fullWidth>
                  <Alert severity="error" style={{ marginBottom: '10px' }}>
                    {error.msg}
                  </Alert>
                </FormControl>
              ) : null}
              <FormControl fullWidth>
                <Button
                  variant="contained"
                  onClick={_onNextPressed}
                  fullWidth
                  size="large"
                  className={classes.btn}
                  type="submit"
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {loading ? <LoadingSpinner size="small" style={{ marginRight: '10px' }} /> : null} Next
                  </Box>
                </Button>
                <div style={{ marginTop: '15px' }}>
                  <Link to={'/login'} onClick={() => setError(null)}>
                    Back
                  </Link>
                </div>
              </FormControl>
            </div>
          </Box>
        </div>
      </div>
    </Box>
  );
}

export default ForgotPasswordForm;
